import { ChatKit, useChatKit } from "@openai/chatkit-react";
import { Box } from "@mui/material";
import { configuration } from "src/configuration";
import { useAccessToken } from "src/http";
import { useBreakpoints } from "src/hooks";

export function ChatPage() {
  const { getAccessToken } = useAccessToken();
  const { isMdUp } = useBreakpoints();

  const { control } = useChatKit({
    composer: {
      placeholder: "Ask me anything...",
      attachments: {
        enabled: true,
        maxSize: 20 * 1024 * 1024,
        maxCount: 3,
      },
    },
    disclaimer: {
      text: "Your interactions with the AI are visible to authorized team members and system administrators. Please avoid sharing sensitive personal information.",
    },
    theme: {
      typography: {
        baseSize: 16,
        fontFamily: "'Open Sans', sans-serif",
      },
      color: {
        accent: {
          primary: "#00838F",
          level: 3,
        },
      },
    },
    startScreen: {
      greeting: "Ask COD-E",
      prompts: [
        {
          label: "What To Focus On This Week",
          prompt:
            "What should I focus on this week based on my owned tasks and strategic items and my teams' goals and priorities?",
          icon: "lightbulb",
        },
        {
          label: "My Home Team Strategy",
          prompt: "Analyze my home team's strategy against the context team one and suggest how to keep them aligned.",
          icon: "book-open",
        },
        {
          label: "Implementation Practice",
          prompt: "How do I ensure my team is using the Implementation Practice properly?",
          icon: "check-circle",
        },
        { label: "How To Start With CODE OS", prompt: "How do I start with CODE OS and the app?", icon: "book-open" },
      ],
    },
    api: {
      async getClientSecret(existing) {
        if (existing) {
          // implement session refresh
        }

        const accessToken = await getAccessToken();
        const deviceId = `device_${Date.now()}`;

        const res = await fetch(`${configuration.apiRootUrl}/mcp/chatkit/session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            workflowId: configuration.chatkitWorkflowId,
            deviceId: deviceId,
          }),
        });

        const { clientSecret } = await res.json();
        return clientSecret;
      },
    },
  });

  return (
    <Box
      sx={{
        width: "100%",
        height: isMdUp ? "100vh" : "calc(100vh - 120px)",
        backgroundColor: "#ffffff",
        overflow: "hidden",
      }}
    >
      <ChatKit control={control} style={{ height: "100%", width: "100%" }} />
    </Box>
  );
}
